import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  divSpaceSection: {
    marginBottom: '20px',
  },
  title: {
    marginBottom: '10px',
    fontWeight: '500',
    color: 'rgba(0, 0, 0, 0.87);',
  },
  locations: {
    fontWeight: '500',
  },
  distanceItem: {
    padding: '12px 12px 5px 12px !important',
  },
  divider: {
    marginBottom: '10px',
  },
  distanceCalculatedContainer: {
    marginBottom: '20px',
    color: 'rgba(0, 0, 0, 0.75)',
    fontSize: '14px',
  },
}));
